import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EsquemaInversionService } from '../../../../../services/esquema-inversion.service';
import { HelpersService } from '../../../../../services/tools/helpers.service';

@Component({
  selector: 'app-eliminar-retiro-modal',
  templateUrl: './eliminar-retiro-modal.component.html',
  styleUrls: ['./eliminar-retiro-modal.component.scss']
})
export class EliminarRetiroModalComponent implements OnInit {

  public errors: any = {};
  public idRetiro: number = 0;

  constructor(
    private helperService: HelpersService,
    private esquemaInversionService: EsquemaInversionService,
    public dialogRef: MatDialogRef<EliminarRetiroModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if(this.data.retiro_id != undefined){
      this.idRetiro = this.data.retiro_id;
      console.log("ID Retiro Eliminar: ", this.idRetiro);
      
    }
  }

  public cerrar(){
    this.dialogRef.close({eliminar:false});
  }

  public aceptar(){
    this.esquemaInversionService.deleteRetiro(this.idRetiro)
     .subscribe(response => {
       const datosRetiro = response.json();
       if (datosRetiro.success) {
         this.helperService.notification('Retiro eliminado', 'Se ha eliminado exitosamente el  retiro de inversión seleccionado', 'success');
         this.dialogRef.close({eliminar:true});
         //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.cerrar();
     });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/devoluciones-inversion-modal/eliminar-retiro-modal/eliminar-retiro-modal.component.ts